import { useState } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { newsList } from '@/mocks/news';
import { getHotMedia } from '@/lib/media';

const INITIAL_COUNT = 4;

export default function News() {
  const [visible, setVisible] = useState(INITIAL_COUNT);
  const shown = newsList.slice(0, visible);
  const hasMore = visible < newsList.length;
  const hotMedia = getHotMedia(5);

  return (
    <div className="mx-auto w-full max-w-[1280px] px-4 py-6 md:px-6 md:py-8">
      <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '影视资讯' }]} />

      <div className="mt-4 mb-6">
        <h1 className="text-2xl font-bold text-foreground-950 font-heading md:text-3xl">影视资讯</h1>
        <p className="mt-2 text-sm text-foreground-500">
          行业动态、影评解读、电影节与影视幕后，为你带来最前沿的影视资讯
        </p>
      </div>

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="lg:col-span-2">
          {shown.length === 0 ? (
            <div className="flex flex-col items-center justify-center rounded-lg bg-background-100 py-20 text-center">
              <i className="ri-newspaper-line text-4xl text-foreground-300" />
              <p className="mt-3 text-sm text-foreground-500">暂无最新影视资讯</p>
            </div>
          ) : (
            <div className="flex flex-col gap-4">
              {shown.map((item) => (
                <Link
                  key={item.id}
                  to={`/news/${item.id}`}
                  className="group flex flex-col gap-4 rounded-lg bg-background-50 p-4 ring-1 ring-background-200/70 transition-all duration-300 hover:ring-accent-300 sm:flex-row"
                >
                  <div className="h-40 w-full shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-28 sm:w-44">
                    <img
                      src={item.cover}
                      alt={item.title}
                      title={`${item.title} - 八戒影院影视资讯`}
                      className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex min-w-0 flex-1 flex-col">
                    <div className="flex items-center gap-2 text-xs text-foreground-500">
                      <span className="rounded bg-accent-100 px-2 py-0.5 font-medium text-accent-700">
                        {item.category}
                      </span>
                      <span>{item.date}</span>
                    </div>
                    <h2 className="mt-2 line-clamp-2 text-base font-bold text-foreground-950 transition-colors group-hover:text-accent-600">
                      {item.title}
                    </h2>
                    <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">
                      {item.summary}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          )}

          {hasMore && (
            <div className="mt-6 flex justify-center">
              <button
                type="button"
                onClick={() => setVisible((v) => v + INITIAL_COUNT)}
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-700 ring-1 ring-background-200 transition-colors hover:bg-background-100"
              >
                <i className="ri-add-line" />
                加载更多
              </button>
            </div>
          )}
        </div>

        <aside className="lg:col-span-1">
          <div className="sticky top-20 flex flex-col gap-6">
            <div className="rounded-lg bg-background-100 p-5">
              <h2 className="mb-4 flex items-center gap-2 text-base font-bold text-foreground-950 font-heading">
                <i className="ri-fire-line text-accent-600" />
                热门影视推荐
              </h2>
              <div className="flex flex-col gap-3">
                {hotMedia.map((item, index) => (
                  <Link
                    key={item.id}
                    to={`/detail/${item.id}`}
                    className="group flex items-center gap-3"
                  >
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-bold ${
                        index < 3 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-500'
                      }`}
                    >
                      {index + 1}
                    </span>
                    <span className="line-clamp-1 flex-1 text-sm text-foreground-700 transition-colors group-hover:text-accent-600">
                      {item.title}
                    </span>
                    <span className="flex items-center gap-1 text-xs font-semibold text-accent-600">
                      <i className="ri-star-fill" />
                      {item.rating.toFixed(1)}
                    </span>
                  </Link>
                ))}
              </div>
            </div>

            <div className="rounded-lg bg-primary-950 p-5">
              <h2 className="mb-3 text-base font-bold text-background-50 font-heading">专题集合</h2>
              <p className="text-sm leading-relaxed text-background-300">
                科幻宇宙、悬疑烧脑、治愈温情……在专题集合中按主题探索更多影视内容。
              </p>
              <div className="mt-4 flex flex-wrap gap-2">
                {['科幻宇宙', '悬疑烧脑', '治愈温情', '武侠国风'].map((tag) => (
                  <Link
                    key={tag}
                    to="/category/movie"
                    className="rounded-full bg-primary-900 px-3 py-1 text-xs text-background-200 transition-colors hover:bg-primary-800 hover:text-secondary-400"
                  >
                    {tag}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </aside>
      </div>
    </div>
  );
}